import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import SEOMeta from '@/components/base/SEOMeta';
import { categoryMap, getMoviesByCategory, type MovieItem } from '@/mocks/movies';

function MovieCard({ movie }: { movie: MovieItem }) {
  const imageUrls: Record<string, string> = {
    'movie-cover-01': 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20distant%20planets%2C%20dramatic%20orange%20and%20deep%20blue%20cosmic%20lighting%2C%20epic%20scale%2C%20clean%20minimal%20composition%2C%20professional%20movie%20poster%20aesthetic%2C%20no%20text%2C%20dark%20atmospheric%20background&width=600&height=840&seq=cat-mc-01&orientation=portrait',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={imageUrls['movie-cover-01']}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-semibold rounded-md whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1 line-clamp-1">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span>{movie.region}</span>
        </div>
      </div>
    </Link>
  );
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryLabel = categoryMap[slug || ''] || '未知分类';
  const movies = getMoviesByCategory(slug || '');

  return (
    <>
      <SEOMeta
        title={`${categoryLabel} - 黄瓜影院`}
        description={`黄瓜影院${categoryLabel}频道，提供最新最热门${categoryLabel}资源免费在线观看。海量高清${categoryLabel}，每日更新，流畅播放。`}
        keywords={`黄瓜影院${categoryLabel},在线${categoryLabel}观看,免费${categoryLabel},高清${categoryLabel}`}
        canonicalUrl={`https://huanggua.tv/category/${slug}`}
      />
      <div className="pt-20 pb-12 md:pb-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8 flex-wrap" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">{categoryLabel}</span>
          </nav>

          <div className="mb-8">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              {categoryLabel}
            </h1>
            <p className="text-sm text-foreground-500">
              共 {movies.length} 部{categoryLabel}资源，持续更新中
            </p>
          </div>

          {movies.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
              {movies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500 text-lg">该分类暂无内容</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}